import axios from '../utils/axios';
import toast from 'react-hot-toast';
import { useMutation } from 'react-query';
import { ERROR_MESSAGES } from '../utils/constants';

const createQuiz = async content => {
    try {
        const resp = await axios.post('/custom', content);
        return resp.data;
    } catch (error) {
        throw error;
    }

};

export const useCreateQuiz = () => {
    const { mutateAsync, isLoading } = useMutation(createQuiz, {
        retry: false,
        onSuccess() {
            toast.success('Quiz creato con successo!');
        },
        onError: (error) => {
            if (error?.code === 'ERR_NETWORK' || error?.code === "ERR_BAD_RESPONSE") {
                toast.error(ERROR_MESSAGES["ERR_NETWORK"]);
                return;
            }
            toast.error(ERROR_MESSAGES[error.response.data.code], { duration: 7000 });
        }
    });
    return {
        createQuiz: mutateAsync,
        isCreating: isLoading,
    };
};